import React from 'react';
import { useTranslation } from 'react-i18next';

interface MObywatelInstructionsProps {
  variant?: 'full' | 'compact';
  className?: string;
}

export const MObywatelInstructions: React.FC<MObywatelInstructionsProps> = ({ variant = 'full', className = '' }) => {
  const { t } = useTranslation();

  const baseClasses =
    variant === 'full' ? 'text-gray-700 text-sm leading-relaxed' : 'text-gray-600 text-xs leading-snug';

  const listClasses = variant === 'full' ? 'list-decimal list-inside space-y-2' : 'list-decimal list-inside space-y-1';

  const titleClasses = variant === 'full' ? 'mb-4 font-medium' : 'mb-2 font-medium text-gray-700';

  return (
    <div className={`${baseClasses} ${className}`}>
      {variant === 'compact' && (
        <p className={titleClasses}>
          {t('MOBYWATEL_VERIFICATION.INSTRUCTIONS_COMPACT_TITLE', 'Jak wprowadzić kod w aplikacji mObywatel:')}
        </p>
      )}
      {variant === 'full' && <p className={titleClasses}>{t('MOBYWATEL_VERIFICATION.INSTRUCTIONS_DESCRIPTION')}</p>}
      <ol className={listClasses}>
        <li dangerouslySetInnerHTML={{ __html: t('MOBYWATEL_VERIFICATION.INSTRUCTIONS.STEP_1') }} />
        <li dangerouslySetInnerHTML={{ __html: t('MOBYWATEL_VERIFICATION.INSTRUCTIONS.STEP_2') }} />
        <li dangerouslySetInnerHTML={{ __html: t('MOBYWATEL_VERIFICATION.INSTRUCTIONS.STEP_3') }} />
        <li dangerouslySetInnerHTML={{ __html: t('MOBYWATEL_VERIFICATION.INSTRUCTIONS.STEP_4') }} />
        <li dangerouslySetInnerHTML={{ __html: t('MOBYWATEL_VERIFICATION.INSTRUCTIONS.STEP_5') }} />
      </ol>
    </div>
  );
};
